<template>
    <router-link :to="{ name: 'shopDetail', params: { id: item.pk } }" class="element">
        <img :src="item.image" id="postIt" alt="" />
        <div id="textWrapper">
            <div>
                {{ item.title }}
            </div>
            <div>
                {{ formatPrice(item.price) }}
            </div>
        </div>
    </router-link>
</template>

<script>
import { store } from "../store";

export default {
    name: "Element",
    props: ["item"],
    data() {
        return {
            store: store,
        };
    },
    methods: {
        formatPrice(price) {
            return "$" + price.toFixed(2);
        },
    },
};
</script>

<style scoped>
.element {
    display: grid;
    padding: 0;
}

p {
    margin: 0;
}

.element>img {
    transition: border-radius 0.2s;
}

/* .element:not(.first):hover > img{ */
.element:hover>img {
    border-radius: 12px;
}

img {
    /* max-height: 100%; */
    max-width: 100%;
    /* min-height: 100%; */
    /* min-width: 100%; */
    /* object-fit: cover; */
    background-color: #d2d2d2;
    aspect-ratio: 3 / 4;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
}

@media only screen and (min-width: 738px) {
    img:hover {
        border-radius: 12px;
    }

    img {
        border-radius: 0;
    }
}

img#postIt.mobileArchive {
    height: 51px;
    width: 51px;
}

img#postIt {
    max-width: unset;
    width: 100%;
    height: auto;
}

#textWrapper {
    display: flex;
    flex-direction: column;
    margin-top: 0.7rem;
}

@media only screen and (min-width: 738px) {
    #textWrapper {
        margin-left: 0;
    }
}
</style>
